// extracted by mini-css-extract-plugin
export var copyableField = "_pn-4";
export var customerBadge = "_pn-0";
export var customerInfoTitle = "_pn-2";
export var details = "_pn-1";
export var dropdownContainer = "_pn-5";
export var dropdownImage = "_pn-6";
export var editAssigneeForm = "_pn-a";
export var editButton = "_pn-3";
export var email = "_pn-7";
export var hidden = "_pn-d";
export var input = "_pn-8";
export var saveButton = "_pn-b";
export var shopifyIcon = "_pn-c";
export var suggestionBadge = "_pn-e";
export var suggestionText = "_pn-f";
export var username = "_pn-9";